<template>
  <el-dialog
    title="用户编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="80px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="role"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
// import {brequest} from '@/utils/brequest'
import { DASHBOARD_MODULE } from '@/utils/params'
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    role: Object,
    menus: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '角色名称',
          field: 'roleName',
          type: 'text',
          disabled: true,
          rules: [{ required: true, message: '角色名称必填', trigger: 'blur' }]
        },
        {
          label: '接口权限',
          field: 'accessResource',
          type: 'text',
          rules: [{ required: true, message: '接口权限必填', trigger: 'blur' }]
        },
        {
          label: '菜单权限',
          field: 'menus',
          type: 'select',
          multiple: true,
          payload: this.menus,
          rules: [{ required: true, message: '菜单必选', trigger: 'blur' }]
        },
        {
          label: '仪表盘',
          field: 'dashboard',
          type: 'select',
          multiple: true,
          payload: DASHBOARD_MODULE,
          rules: [{ required: true, message: '仪表盘必选', trigger: 'blur' }]
        }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
